import SubmitData from './SubmitData'
export default SubmitData

export const buttonTextOptions = {
  ready: 'Save & Upload',
  uploading: 'Uploading...',
  success: 'Done!',
}
